import Expander from '@sats-group/ui-lib/react/expander';
import React from 'react';
import { BlockType } from '~/shared/content-block-helpers';
import Carousel from '../carousel/carousel';
import ComponentList from '../component-list/component-list';
import ContentElement from '../content-element/content-element';
import CTABanner from '../cta-banner/cta-banner';
import EmbedYoutube from '../embed-youtube/embed-youtube';
import LinksBlock from '../links-block/links-block';
import PreviewCard from '../preview-card/preview-card';
import ProfileCard from '../profile-card/profile-card';
import Quote from '../quote/quote';
import RichText from '../rich-text/rich-text';
import Showcase from '../showcase/showcase';
import SplitInfoModule from '../split-info-module/split-info-module';
import TextModule from '../text-module/text-module';
import UniqueSellingPoint from '../unique-selling-point/unique-selling-point';
import UspList from '../usp-list/usp-list';
import VideoBlock from '../video-block/video-block';
import VideoCard from '../video-card/video-card';
import ContentBlock from './content-block';
import type { ContentBlocks as ContentBlocksProps } from './content-blocks.types';

const ContentBlocks: React.FC<ContentBlocksProps> = ({ blocks }) => (
  <div className="content-blocks">
    <div className="content-blocks__blocks">
      {blocks.map(block => {
        switch (block.type) {
          case BlockType.ArticleCardCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={PreviewCard} />
              </ContentBlock>
            );
          }
          case BlockType.ArticleCardComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ComponentList {...block.props} entryRenderer={PreviewCard} />
              </ContentBlock>
            );
          }
          case BlockType.ContentElementCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={ContentElement} />
              </ContentBlock>
            );
          }
          case BlockType.ContentElementComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ComponentList
                  {...block.props}
                  entryRenderer={ContentElement}
                />
              </ContentBlock>
            );
          }
          case BlockType.Expander: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Expander {...block.props} itemRenderer={RichText} />
              </ContentBlock>
            );
          }
          case BlockType.LinksBlock: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <LinksBlock {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.ProductBox: {
            return (
              <ContentBlock
                center={true}
                id={block.key}
                key={block.key}
                type={block.type}
              >
                <CTABanner {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.ProfileCardCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={ProfileCard} />
              </ContentBlock>
            );
          }
          case BlockType.ProfileCardComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ComponentList {...block.props} entryRenderer={ProfileCard} />
              </ContentBlock>
            );
          }
          case BlockType.Quote: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Quote {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.QuoteCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={Quote} />
              </ContentBlock>
            );
          }
          case BlockType.QuoteComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ComponentList {...block.props} entryRenderer={Quote} />
              </ContentBlock>
            );
          }
          case BlockType.Showcase: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Showcase {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.SplitInfoModule: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <SplitInfoModule {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.TextModule: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <TextModule {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.TextModuleCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={TextModule} />
              </ContentBlock>
            );
          }
          case BlockType.TextModuleComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ComponentList {...block.props} entryRenderer={TextModule} />
              </ContentBlock>
            );
          }
          case BlockType.UspCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={UniqueSellingPoint} />
              </ContentBlock>
            );
          }
          case BlockType.UspComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ComponentList
                  {...block.props}
                  entryRenderer={UniqueSellingPoint}
                />
              </ContentBlock>
            );
          }
          case BlockType.UspList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <UspList {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.VideoBlock: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <VideoBlock {...block.props} />
              </ContentBlock>
            );
          }
          case BlockType.VideoCardCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <Carousel {...block.props} entryRenderer={VideoCard} />
              </ContentBlock>
            );
          }
          case BlockType.YoutubeEmbed: {
            return (
              <ContentBlock
                center
                id={block.key}
                key={block.key}
                type={block.type}
              >
                <div className="content-blocks__youtube-embed">
                  <EmbedYoutube {...block.props} />
                </div>
              </ContentBlock>
            );
          }
        }
      })}
    </div>
  </div>
);

export default ContentBlocks;
